import getUAString from "./auth-service-tools1179.js";

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

export { isLayoutViewport as default };